import styles from './lightning-spinner.module.css';

const ringPath = 'M60 15 70 18 76 14 81 24 93 25 91 35 104 41 100 51 107 59 101 68 105 78 94 82 93 95 81 94 74 105 64 100 54 106 47 99 34 102 31 91 19 87 23 75 13 68 20 57 15 46 26 41 25 30 38 29 43 18 53 21Z';

type LightningSpinnerProps = {
  label?: string;
};

const LightningSpinner = ({ label = 'Загрузка…' }: LightningSpinnerProps) => (
  <div className={styles.spinner} role="status">
    <svg className={styles.graphic} viewBox="0 0 120 120" aria-hidden="true" focusable="false">
      <path className={styles.ring} d={ringPath} />
      <path className={`${styles.current} ${styles.glow}`} pathLength="100" d={ringPath} />
      <path className={styles.current} pathLength="100" d={ringPath} />
      <path className={styles.bolt} d="M65 38 46 63h13l-3 19 20-28H62Z" />
    </svg>
    <span className={styles.label}>{label}</span>
  </div>
);

export default LightningSpinner;
